export default __webpack_public_path__ + "static/media/down-blue.1a94e034.svg";